import { Component, OnInit } from '@angular/core';
import { GenericRelatorioComponent } from '../generic-relatorio.component';
import { Breadcrumb, GenerateTableColumn, GenerateTablePageEvent, GenerateTablePagination } from 'src/app/shared/components';
import { Beneficiaria, BeneficiariaService } from 'src/app/beneficiaria';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContratoService } from 'src/app/contrato';
import { RelatorioService } from '../relatorio.service';
import dayjs from 'dayjs';
import { catchErr } from 'src/app/shared/utils';

@Component({
    selector: 'app-pendencias-de-faturamento',
    templateUrl: './pendencias-de-faturamento.component.html',
    standalone: false
})
export class PendenciasDeFaturamentoComponent extends GenericRelatorioComponent implements OnInit {
  
  breadcrumb: Breadcrumb[] = [
          { label: 'Início' },
          { label: 'Relatórios', route: '/relatorio' },
          { label: 'Pendências de Faturamento' },
  ]

  dataSource: any[];
  pagination: GenerateTablePagination = { total: 0, current: 0, pageSize: 10 };
  columns: GenerateTableColumn[] = [
      { header: '#', attr: 'index' },
      { header: 'DIO', attr: 'numeroDio' },
      { header: 'Prefixo', attr: 'prefixo' },
      { header: 'Contrato', attr: 'contrato' },            
      { header: 'Equipamento', attr: 'placa' },
      { header: 'Início Operação', attr: 'dataInicioOperacao' },   
      { header: 'Condutor', attr: 'condutor' },   
      { header: 'Status Execução', attr: 'statusExecucao' },      
  ];

  constructor(
    private relatorioService: RelatorioService,
    protected override beneficiariaService: BeneficiariaService,
    protected override snackBar: MatSnackBar,
  ) {   
    super(beneficiariaService, snackBar);
  }

  ngOnInit(): void {
    this.toggleFilters = true;
  }

  setBeneficiaria(beneficiaria: Beneficiaria) {
    this.filters.contrato = undefined;
    this.beneficiariaService.getContratos(beneficiaria.id!).subscribe({
        next: (res) => this.contratos = res,
        error: (err) => catchErr(err, this.snackBar)
    }).add(() => this.loading = false);
  }

  search(pageEvent?: GenerateTablePageEvent) {
    this.loading = true;
    this.pagination.current = pageEvent ? pageEvent.current : this.pagination.current;
    this.pagination.pageSize = pageEvent ? pageEvent.pageSize : this.pagination.pageSize;

    const filters = { ...this.filters };
    filters.dataInicio = filters.dataInicio ? `${dayjs(filters.dataInicio).format('YYYY-MM-DD')}` : filters.dataInicio;
    filters.dataFim = filters.dataFim ? `${dayjs(filters.dataFim).format('YYYY-MM-DD')}` : filters.dataFim;

    this.relatorioService.getPendenciasDeFaturamento(this.pagination.current, this.pagination.pageSize, filters).subscribe({
        next: (res: any) => {
            if (res.report.data) {
                this.dataSource = res.report.data.map((item: any, index: number) => this.buildResponse(item, index));
            }
            this.pagination.total = res.report.total;
        }
    }).add(() => this.loading = false);
  }

  buildResponse(item: any, index: number) {
    return {
      index: index + 1,
      numeroDio: item.numeroDio,
      prefixo: item.prefixo,
      contrato: item.contrato,
      placa: item.placa,
      dataInicioOperacao: item.dataOperacao ? dayjs(item.dataOperacao).format('DD/MM/YYYY') : '-',
      statusExecucao: item.statusExecucao,      
      condutor: item.condutor,
      nomeContrato: item.nomeContrato,            
    };
  }

  export(type: string = 'csv') {
    // Implement export logic here
  }

}